import script from "./deliverGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./deliverGoods.vue?vue&type=script&setup=true&lang=js"

import "./deliverGoods.vue?vue&type=style&index=0&id=4bc20a21&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc20a21"]])

export default __exports__